import styled from "styled-components";
import { CardTitle, CardBody } from "reactstrap";
import { theme } from "../../constants/theme";

export const StepBadge = styled.div`
  position: relative;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  background:
    radial-gradient(circle at 30% 28%, rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0) 55%),
    ${({ color }) => color || theme.color.stepBlue};
  color: ${theme.color.slate};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${theme.font.display};
  font-size: 1.1rem;
  font-weight: ${theme.weight.semibold};
  letter-spacing: -0.01em;
  margin: 0 auto 1rem;
  box-shadow:
    0 4px 10px rgba(46, 58, 82, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.55),
    inset 0 -1px 0 rgba(46, 58, 82, 0.08);
`;

export const InstructionTitle = styled(CardTitle)`
  font-family: ${theme.font.display};
  font-weight: ${theme.weight.semibold};
  font-size: 1.25rem;
  letter-spacing: -0.02em;
  color: ${theme.color.slate};
  text-align: center;
  min-height: 4rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const InstructionBody = styled(CardBody)`
  text-align: left;
  margin: 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  color: ${theme.color.text};
  line-height: 1.65;

  p {
    margin-bottom: 0.75rem;
    text-align: justify;
  }
`;

export const InstructionCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const InstructionContent = styled.div`
  flex: 1;
`;

export const InstructionFooter = styled.div`
  margin-top: auto;
`;
